import { render, staticRenderFns } from "./EditorTextAreaTemplate.vue?vue&type=template&id=25b73366"
import script from "./EditorTextAreaTemplate.vue?vue&type=script&lang=js"
export * from "./EditorTextAreaTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports